import {  Button, Grid, Paper } from "@material-ui/core";
import Box from '@mui/material/Box';
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useAddMoney } from "../../../../shared/context";
import "../../../StashKar/style.scss";
import BackgroundTheme from "../../../../Common/P2P/Header/BackgroundTheme";
import CardsTheme from "../../../../Common/P2P/Header/CardsTheme";
import Typography from "@mui/material/Typography";

const investmentBox = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "15px 0px",
};

const InvestMore = () => {
  const history = useHistory();
  const { state, dispatch } = useAddMoney();

  const [setReturnValue, returnValue] = useState({
    id: 3,
    expectedReturns: 8.4,
  });

  const [returnData, setReturnData] = useState([
    { id: 3, expectedReturns: 8.4, isSelected: true },
    { id: 6, expectedReturns: 9.4, isSelected: false },
    { id: 12, expectedReturns: 12, isSelected: false },
  ]);

  const investMore = () => {
    history.push({
      pathname: "/p2p/addmoney",
    });
  };

  const investNow = () => {
    history.push({
      pathname: "/p2p/bank-detail",
    });
  };

  const onClickMonth = (month: number) => {
    const expReturnValue = [...returnData];
    const returnValueData = expReturnValue.find((r: any) => r.id === month);
    for (let i = 0; i < expReturnValue.length; i++) {
      if (expReturnValue[i].id === month) expReturnValue[i].isSelected = true;
      else expReturnValue[i].isSelected = false;
    }
    if (returnValueData) returnValue(returnValueData);
    setReturnData(expReturnValue);
    return true;
  };

  return (
    <>
    <BackgroundTheme>
      <Grid>
        <CardsTheme>
          <Box style={{ padding: "10px" }}>
            <Typography component="p"><strong>calculate your est. returns</strong></Typography>
            <Box style={investmentBox}>
              <Typography component="span">Total invesment </Typography>
              <Typography style={{ color: "#000066", fontWeight: "bold" }}>
                {" "}
                {(state && state?.amount) || 0}
              </Typography>
              <Box style={investmentBox}>
                <Typography>Total invesment </Typography>
                <Typography> {(state && state?.amount) || 0}</Typography>
              </Box>
              <div className="divider"></div>
              <Box style={investmentBox}>
                <Typography>expected returns (p.a)</Typography>
                <Typography> {setReturnValue.expectedReturns} %</Typography>
              </Box>
              <div className="divider"></div>
              <Box style={investmentBox}>
                <Typography>Time Period</Typography>
                <Typography> {setReturnValue.id}</Typography>
              </Box>
              <div className="divider"></div>
            </Box>
            <div
              style={{ borderBottom: "1px solid #68686A", margin: "0 10px" }}
            ></div>
            <Box style={investmentBox}>
              <Typography component="span">expected returns (p.a)</Typography>
              <Typography style={{ color: "#000066", fontWeight: "bold" }}>
                {" "}
                {setReturnValue.expectedReturns} %
              </Typography>
            </Box>
            <div
              style={{ borderBottom: "1px solid #68686A", margin: "0 10px" }}
            ></div>
            <Box style={investmentBox}>
              <Typography component="span">Time period</Typography>
              <Typography style={{ color: "#000066", fontWeight: "bold" }}>
                {" "}
                {setReturnValue.id}
              </Typography>
            </Box>
            </Box>
          </CardsTheme>
          <Box className="investMoreBtn">
            <Button
              variant="contained"
              color="primary"
              onClick={() => investMore()}
            >
              invest more
            </Button>
            <Button variant="outlined" onClick={() => investNow()}>
              invest now
            </Button>
          </Box>
        </Grid>
      </BackgroundTheme>
    </>
  );
};

export default InvestMore;